import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const CreatePasswordContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const CreatePasswordTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const CreatePasswordSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "44px",
}));

export const CreatePasswordForm = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "12px", // 12px margin between inputs
}));

export const CreatePasswordActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "24px",
  alignItems: "center",
  marginTop: "32px",
}));

